module.exports = __webpack_public_path__ + "static/img/homebanner3.b1c40a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homebanner3.png
// module id = hELo
// module chunks = 2